import { http } from '../../../../api/http';
import type { MovimientoInventario, MovimientoRequest } from '../types/movimiento.types';

export const movimientoInventarioService = {
  async getAll(filters?: { tipo?: string; idDeposito?: number; fechaDesde?: string; fechaHasta?: string }): Promise<MovimientoInventario[]> {
    const params = new URLSearchParams();
    if (filters?.tipo) params.append('tipo', filters.tipo);
    if (filters?.idDeposito) params.append('idDeposito', filters.idDeposito.toString());
    if (filters?.fechaDesde) params.append('fechaDesde', filters.fechaDesde);
    if (filters?.fechaHasta) params.append('fechaHasta', filters.fechaHasta);
    const response = await http.get(`/inventario/movimiento?${params.toString()}`);
    return response.data;
  },

  async getById(id: number): Promise<MovimientoInventario> {
    const response = await http.get(`/inventario/movimiento/${id}`);
    return response.data;
  },

  async create(request: MovimientoRequest): Promise<MovimientoInventario> {
    const response = await http.post('/inventario/movimiento', request);
    return response.data;
  },

  async anular(id: number): Promise<void> {
    await http.put(`/inventario/movimiento/${id}/anular`);
  },
};
